<ion-grid class="wrapper" *transloco="let t; prefix: 'studyProgressBarComp'">
  <ion-row class="ion-align-items-end">
    <ion-col>
      <ion-row class="ion-align-items-end ion-justify-content-between ion-padding-bottom">
        <ion-col class="ion-text-uppercase"> {{ isTypeCamp?  t('titleTypeCamp') : t('title') }}</ion-col>
        <ion-col size="auto"> {{ duration }} </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="result"> {{ currentLesson }} / {{ totalLessons }}</ion-col>
      </ion-row>
      <ion-row>
        <ion-col>

          <div class="progress-bar-wrapper">
            <div class="progress-bar" [style.width.%]="studyProgress"></div>
          </div>

        </ion-col>
      </ion-row>

    </ion-col>
    <ion-col size="auto" class="image">
     <img src="assets/images/study/progress.png" alt="progress">
    </ion-col>
  </ion-row>
</ion-grid>
